import { render } from "./EventJournal.vue?vue&type=template&id=f3804644&scoped=true"
import script from "./EventJournal.vue?vue&type=script&lang=js"
export * from "./EventJournal.vue?vue&type=script&lang=js"

import "./EventJournal.vue?vue&type=style&index=0&id=f3804644&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3804644"]])

export default __exports__